<div class="pt-4">
    <div id="{{'questionTrendsClosedResult' + chartId}}"></div>
</div>
